/* eslint-disable */ 
import React from 'react' ;
import { Button as ButtonIm} from 'primereact/button';


export default function Button (props) {

    return <ButtonIm {...props} />
    
}